export {
  default,
  EventDetailLoadingSkeleton,
} from '@/features/events/eventDetail/EventDetailScreen';
